"use client";

import type { FeederHoliday } from "@/lib/conditions/timing-data";

type Props = {
  feederHolidays: FeederHoliday[];
};

const COUNTRY_NAMES: Record<string, string> = {
  GB: "United Kingdom", FR: "France", DE: "Germany", NL: "Netherlands",
  AT: "Austria", CH: "Switzerland", AU: "Australia", US: "United States",
  CA: "Canada", JP: "Japan", IT: "Italy", ES: "Spain", SE: "Sweden",
  NO: "Norway", DK: "Denmark", FI: "Finland", BE: "Belgium", IE: "Ireland",
  PT: "Portugal", NZ: "New Zealand", BR: "Brazil", ZA: "South Africa",
  MX: "Mexico", CR: "Costa Rica", ID: "Indonesia", PH: "Philippines",
  HK_SG: "Hong Kong / Singapore", CZ: "Czechia", PL: "Poland",
  RU: "Russia", IL: "Israel", KR: "South Korea",
};

function formatDateRange(start: string, end: string): string {
  const s = new Date(start + "T00:00:00Z");
  const e = new Date(end + "T00:00:00Z");
  const sameMonth = s.getUTCMonth() === e.getUTCMonth();
  if (sameMonth) {
    return `${s.getUTCDate()}-${e.toLocaleDateString("en-GB", { day: "numeric", month: "long" })}`;
  }
  return `${s.toLocaleDateString("en-GB", { day: "numeric", month: "short" })} - ${e.toLocaleDateString("en-GB", { day: "numeric", month: "short" })}`;
}

export function CrowdCalendar({ feederHolidays }: Props) {
  if (feederHolidays.length === 0) return null;
  return (
    <div>
      <h4 className="text-[12px] font-semibold uppercase tracking-[1.2px] text-text-muted mb-3">
        School holidays affecting this destination
      </h4>
      <div className="space-y-2">
        {feederHolidays.map((h, i) => (
          <div
            key={i}
            className="flex items-center justify-between py-2 border-b border-border-light last:border-b-0 text-[13px]"
          >
            <div className="flex-1 min-w-0">
              <span className="font-semibold text-navy">{h.holidayName}</span>
              <span className="text-text-muted ml-2">
                ({COUNTRY_NAMES[h.countryCode] ?? h.countryCode})
              </span>
            </div>
            <span className="text-text-muted text-[12px] shrink-0 ml-3">
              {formatDateRange(h.startDate, h.endDate)}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
